import { render, staticRenderFns } from "./StationRegistrationPopup.vue?vue&type=template&id=6981710c&"
import script from "./StationRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./StationRegistrationPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports